import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { defineMessages, FormattedMessage } from 'react-intl';
import { Referral, ReferralState } from '../../../types';
import { nestedUrls } from '../../../const';
import { isSplittingState, userIsUnitMember } from '../../../utils/referral';
import { useCurrentUser } from '../../../data/useCurrentUser';
import { Nullable } from '../../../types/utils';
import { ReferralContext } from '../../../data/providers/ReferralProvider';
import { useIntl } from 'react-intl';

const messages = defineMessages({
  answer: {
    defaultMessage: 'Answer',
    description:
      'Link & breadcrumb title for the tab link to the final answer for the referral.',
    id: 'components.ReferralTabs.answer',
  },
  draftAnswer: {
    defaultMessage: 'Draft answer',
    description:
      'Link & breadcrumb title for the tab link to the draft answers for the referral.',
    id: 'components.ReferralTabs.draftAnswer',
  },
  messages: {
    defaultMessage: 'Messages',
    description:
      'Link and breadcrumb title for the tab link to the referral messages.',
    id: 'components.ReferralTabs.messages',
  },
  requesters: {
    defaultMessage: 'Requesters',
    description: 'Text link to the requesters tab link.',
    id: 'components.ReferralTabs.requesters',
  },
  unavailableRequesterTab: {
    defaultMessage: 'Adding requesters is not avaiblable in a splitting mode',
    description: 'Unavailable requester tab text',
    id: 'components.ReferralTabs.unavailableRequesterTab',
  },
  linkToContent: {
    defaultMessage: 'Referral',
    description: 'Link title for the tab link to the referral content.',
    id: 'components.ReferralTabs.linkToContent',
  },
  tracking: {
    defaultMessage: 'Tracking',
    description:
      'Link & breadcrumb title for the tab link to the referral tracking.',
    id: 'components.ReferralTabs.tracking',
  },
  draftAnswers: {
    defaultMessage: 'Draft answers',
    description:
      'Link & breadcrumb title for the tab link to the draft answers for the referral.',
    id: 'components.ReferralTabs.draftAnswers',
  },
});

export const OldReferralTabs = () => {
  const { referral }: { referral: Nullable<Referral> } = useContext(
    ReferralContext,
  );

  const { currentUser }: any = useCurrentUser();
  const intl = useIntl();

  return (
    <>
      {referral && (
        <div className="old-tab-group">
          <NavLink
            className="old-tab space-x-2"
            to={nestedUrls.content}
            aria-current="true"
          >
            <FormattedMessage {...messages.linkToContent} />
          </NavLink>
          <NavLink
            className="old-tab space-x-2"
            to={nestedUrls.tracking}
            aria-current="true"
          >
            <FormattedMessage {...messages.tracking} />
          </NavLink>

          {!isSplittingState(referral) ? (
            <NavLink
              className="old-tab space-x-2"
              to={nestedUrls.users}
              aria-current="true"
            >
              <FormattedMessage {...messages.requesters} />
            </NavLink>
          ) : (
            <a
              className="old-tab space-x-2 disabled tooltip tooltip-info"
              data-tooltip={intl.formatMessage(
                messages.unavailableRequesterTab,
              )}
            >
              <FormattedMessage {...messages.requesters} />
            </a>
          )}
          <NavLink
            onClick={(e) =>
              referral!.state === ReferralState.SPLITTING && e.preventDefault()
            }
            className={`old-tab space-x-2 ${
              referral!.state === ReferralState.SPLITTING ? 'disabled' : ''
            }`}
            to={nestedUrls.messages}
            aria-current="true"
          >
            <FormattedMessage {...messages.messages} />
          </NavLink>

          {userIsUnitMember(currentUser, referral!) ? (
            <NavLink
              className="old-tab space-x-2"
              to={
                referral!['feature_flag']
                  ? nestedUrls.draftAnswer
                  : nestedUrls.draftAnswers
              }
              aria-current="true"
            >
              <FormattedMessage {...messages.draftAnswer} />
            </NavLink>
          ) : null}

          {referral!.state === ReferralState.ANSWERED ||
          referral!.report!.publishments.length > 0 ? (
            <NavLink
              className="old-tab space-x-2"
              to={nestedUrls.answer}
              aria-current="true"
            >
              <FormattedMessage {...messages.answer} />
            </NavLink>
          ) : (
            <a className="old-tab space-x-2 disabled">
              <FormattedMessage {...messages.answer} />
            </a>
          )}
        </div>
      )}
    </>
  );
};
